<img [ngStyle]="{ 'width': width, 'height': width }" [src]="src">